export const GET_DEVICE_TYPE = {
    INIT: "GET_DEVICE_TYPE_INIT",
    SUCCESS: "GET_DEVICE_TYPE_SUCCESS",
    ERROR: "GET_DEVICE_TYPE_ERROR",
};

export const GET_DEVICE_ONBOARDING_LOGS = {
    INIT: "GET_DEVICE_ONBOARDING_LOGS_INIT",
    SUCCESS: "GET_DEVICE_ONBOARDING_LOGS_SUCCESS",
    ERROR: "GET_DEVICE_ONBOARDING_LOGS_ERROR",
};

export const GET_PROCESS_NAMES = {
    INIT: "GET_PROCESS_NAMES_INIT",
    SUCCESS: "GET_PROCESS_NAMES_SUCCESS",
    ERROR: "GET_PROCESS_NAMES_ERROR",
};
